var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2.4,
    fill: "#EF8B6C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15039 18V5.91406H12.3838C13.8503 5.91406 14.9626 6.19629 15.7207 6.76074C16.4788 7.31966 16.8579 8.14144 16.8579 9.22607C16.8579 9.8182 16.7057 10.3411 16.4014 10.7949C16.097 11.2432 15.6737 11.5724 15.1313 11.7827C15.7511 11.9377 16.2381 12.2503 16.5923 12.7207C16.952 13.1911 17.1318 13.7666 17.1318 14.4473C17.1318 15.6094 16.7611 16.4893 16.0195 17.0869C15.278 17.6846 14.221 17.9889 12.8486 18H8.15039ZM10.6406 12.7373V15.9995H12.7739C13.3605 15.9995 13.8171 15.8612 14.1436 15.5845C14.4756 15.3022 14.6416 14.9149 14.6416 14.4224C14.6416 13.3156 14.0688 12.7539 12.9233 12.7373H10.6406ZM10.6406 10.9775H12.4834C13.7396 10.9554 14.3677 10.4546 14.3677 9.4751C14.3677 8.92725 14.2072 8.53434 13.8862 8.29639C13.5708 8.0529 13.07 7.93115 12.3838 7.93115H10.6406V10.9775Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasic);
export default __webpack_public_path__ + "static/media/basic.bf20f176f6f5a22bb34f9d2c8cd072f3.svg";
export { ForwardRef as ReactComponent };